/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { JobFrequency } from './JobFrequency';
import {
    instanceOfJobFrequency,
    JobFrequencyFromJSON,
    JobFrequencyFromJSONTyped,
    JobFrequencyToJSON,
} from './JobFrequency';

/**
 * @type JobScheduleDtoFrequency
 * 
 * @export
 */
export type JobScheduleDtoFrequency = JobFrequency;


export function JobScheduleDtoFrequencyFromJSON(json: any): JobScheduleDtoFrequency {
    return JobScheduleDtoFrequencyFromJSONTyped(json, false);
}

export function JobScheduleDtoFrequencyFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobScheduleDtoFrequency {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...JobFrequencyFromJSONTyped(json, true) };
    return  JobFrequencyFromJSONTyped(json, true);
}

export function JobScheduleDtoFrequencyToJSON(value?: JobScheduleDtoFrequency | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfJobFrequency(value)) {
        return JobFrequencyToJSON(value as JobFrequency);
    }

    return {};
}

/**
 * Check if a given object implements the JobScheduleDtoFrequency interface.
 */
export function instanceOfJobScheduleDtoFrequency(value: any): value is JobScheduleDtoFrequency {
    if (instanceOfJobFrequency(value)) return true;
    return false;
}

